import { useModal } from '../../../components/ModalProvider';
import { useEmployee } from '../EmployeeContext';
import { SignatureCapture } from './SignatureCapture';
import { DocumentPhotoCapture } from './DocumentPhotoCapture';
import { ErrorModalBody } from '../../../components/ErrorModalBody';

export function useEnsureOnboarding() {
  const { signature, documentPhoto, refresh } = useEmployee();
  const { showModal, closeModal } = useModal();

  function proceed(sig: any, doc: any, action: () => void | Promise<void>) {
    if (!sig) {
      showModal(
        <SignatureCapture
          onSaved={async () => {
            try {
              const fresh = await refresh();
              closeModal();
              proceed(fresh.signature, fresh.documentPhoto, action);
            } catch (err) {
              showModal(<ErrorModalBody error={err} onClose={closeModal} />);
            }
          }}
        />,
      );
      return;
    }
    if (!doc) {
      showModal(
        <DocumentPhotoCapture
          onSaved={async () => {
            try {
              const fresh = await refresh();
              closeModal();
              proceed(fresh.signature, fresh.documentPhoto, action);
            } catch (err) {
              showModal(<ErrorModalBody error={err} onClose={closeModal} />);
            }
          }}
        />,
      );
      return;
    }
    try {
      const result = action();
      if (result && typeof (result as Promise<void>).catch === 'function') {
        (result as Promise<void>).catch((err) => showModal(<ErrorModalBody error={err} onClose={closeModal} />));
      }
    } catch (err) {
      showModal(<ErrorModalBody error={err} onClose={closeModal} />);
    }
  }

  return function runGated(action: () => void | Promise<void>) {
    proceed(signature, documentPhoto, action);
  };
}
